import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Card/card';
import { css } from '@patternfly/react-styles';
export var Card = function Card(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'article' : _a$component,
      _a$isHoverable = _a.isHoverable,
      isHoverable = _a$isHoverable === void 0 ? false : _a$isHoverable,
      _a$isCompact = _a.isCompact,
      isCompact = _a$isCompact === void 0 ? false : _a$isCompact,
      _a$isSelectable = _a.isSelectable,
      isSelectable = _a$isSelectable === void 0 ? false : _a$isSelectable,
      _a$isSelected = _a.isSelected,
      isSelected = _a$isSelected === void 0 ? false : _a$isSelected,
      _a$isFlat = _a.isFlat,
      isFlat = _a$isFlat === void 0 ? false : _a$isFlat,
      props = __rest(_a, ["children", "className", "component", "isHoverable", "isCompact", "isSelectable", "isSelected", "isFlat"]);

  var Component = component;
  return React.createElement(Component, Object.assign({
    className: css(styles.card, isHoverable && styles.modifiers.hoverable, isCompact && styles.modifiers.compact, isSelectable && styles.modifiers.selectable, isSelected && isSelectable && styles.modifiers.selected, isFlat && styles.modifiers.flat, className),
    tabIndex: isSelectable ? '0' : undefined
  }, props), children);
};